import { ChevronLeft, ChevronRight } from "lucide-react";

// Page buttons: Previous, 1 2 3 ... , Next.
export function Pager({ page, totalPages, onChange }) {
  if (totalPages <= 1) return null;

  const items = [];
  for (let p = 1; p <= totalPages; p++) {
    if (p === 1 || p === totalPages || Math.abs(p - page) <= 1) items.push(p);
    else if (items[items.length - 1] !== "…") items.push("…");
  }

  const base =
    "inline-flex h-9 min-w-9 items-center justify-center rounded-full border px-3 text-sm font-medium transition-colors";

  return (
    <nav aria-label="Pages" className="mt-6 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => onChange(page - 1)}
        disabled={page === 1}
        className={`${base} border-border hover:bg-secondary disabled:opacity-40`}
      >
        <ChevronLeft className="mr-1 h-4 w-4" /> Previous
      </button>

      {items.map((p, i) =>
        p === "…" ? (
          <span key={`gap-${i}`} className="px-1 text-muted-foreground">…</span>
        ) : (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            aria-current={p === page ? "page" : undefined}
            className={`${base} ${
              p === page
                ? "border-[#C89B3C] bg-[#C89B3C] text-black"
                : "border-border hover:bg-secondary"
            }`}
          >
            {p}
          </button>
        )
      )}

      <button
        type="button"
        onClick={() => onChange(page + 1)}
        disabled={page === totalPages}
        className={`${base} border-border hover:bg-secondary disabled:opacity-40`}
      >
        Next <ChevronRight className="ml-1 h-4 w-4" />
      </button>
    </nav>
  );
}